import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../../components/modal'
import Input from '../../../../components/input'

const PaymentFormModal = ({
    isOpen,
    onClose,
    onSubmit,
    formData,
    onChange,
    paymentMethodOptions,
    paymentStatusOptions,
    isEditing,
    t,
    agentName
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t(isEditing ? 'AGENT_COMMISSIONS_PAYMENT_MODAL_TITLE_EDIT' : 'AGENT_COMMISSIONS_PAYMENT_MODAL_TITLE_ADD')}
            subtitle={agentName}
            icon="zmdi-money"
            size="medium"
            className="commission-detail-modal"
        >
            <form onSubmit={onSubmit} className="payment-form">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label>{t('AGENT_COMMISSIONS_PAYMENT_AMOUNT')}</label>
                            <Input
                                type="number"
                                name="amount"
                                value={formData.amount}
                                onChange={onChange}
                                placeholder="1000"
                                required
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label>{t('AGENT_COMMISSIONS_PAYMENT_DATE')}</label>
                            <Input
                                type="date"
                                name="paymentDate"
                                value={formData.paymentDate}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label>{t('AGENT_COMMISSIONS_PAYMENT_METHOD')}</label>
                            <select
                                name="paymentMethod"
                                className="form-control"
                                value={formData.paymentMethod}
                                onChange={onChange}
                                required
                            >
                                <option value="">{t('COMMON_SELECT')}</option>
                                {paymentMethodOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="form-group">
                            <label>{t('AGENT_COMMISSIONS_PAYMENT_REFERENCE')}</label>
                            <Input
                                type="text"
                                name="referenceNumber"
                                value={formData.referenceNumber}
                                onChange={onChange}
                                placeholder="TR123456789"
                            />
                        </div>
                    </div>
                    {isEditing && (
                        <div className="col-12 col-md-6">
                            <div className="form-group">
                                <label>{t('AGENT_COMMISSIONS_PAYMENT_STATUS')}</label>
                                <select
                                    name="status"
                                    className="form-control"
                                    value={formData.status}
                                    onChange={onChange}
                                >
                                    <option value="">{t('COMMON_SELECT')}</option>
                                    {paymentStatusOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                    <div className="col-12">
                        <div className="form-group">
                            <label>{t('AGENT_COMMISSIONS_PAYMENT_DESCRIPTION')}</label>
                            <Input
                                type="text"
                                name="description"
                                value={formData.description}
                                onChange={onChange}
                                placeholder={t('AGENT_COMMISSIONS_PAYMENT_DESCRIPTION')}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <label>{t('AGENT_COMMISSIONS_PAYMENT_NOTES')}</label>
                            <textarea
                                name="notes"
                                className="form-control"
                                rows="3"
                                value={formData.notes}
                                onChange={onChange}
                                placeholder={t('AGENT_COMMISSIONS_PAYMENT_NOTES')}
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className="modal-actions text-right">
                    <button type="button" className="btn btn-secondary m-r-10" onClick={onClose}>
                        {t('COMMON_CANCEL')}
                    </button>
                    <button type="submit" className="btn btn-primary">
                        {t(isEditing ? 'AGENT_COMMISSIONS_PAYMENT_UPDATE' : 'AGENT_COMMISSIONS_PAYMENT_SAVE')}
                    </button>
                </div>
            </form>
        </Modal>
    )
}

PaymentFormModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    formData: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    paymentMethodOptions: PropTypes.array.isRequired,
    paymentStatusOptions: PropTypes.array.isRequired,
    isEditing: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    agentName: PropTypes.string.isRequired
}

export default PaymentFormModal

